import React, { useState } from "react";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";

export default function LogoutAllDevicesModal({ show, onClose }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [error, setError] = useState("");
  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();

  if (!show) return null;

  const handleLogoutAll = async () => {
    setIsLoading(true);
    setError("");

    try {
      const response = await axios.post(
        `${ApiConnectionString}/api/Account/SignOutAllDevices`,
        {},
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      if (response.status === 200) {
        dispatch({ type: "LOGOUT" });
        navi("/");
        setIsComplete(true);
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setIsComplete(false);
    setError("");
    onClose();
  };

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title brand-purple">
                {isComplete ? "Logged out everywhere" : "Log out of all devices"}
              </h5>
              <button type="button" className="btn-close" onClick={handleClose}></button>
            </div>

            {isComplete ? (
              /* SUCCESS STATE */
              <div className="modal-body text-center py-4">
                <div className="alert alert-success mb-4">
                  You have been logged out on all devices.
                </div>

                <button
                  className="btn brand-purple-inline"
                  onClick={() => {
                    navi("/");
                    handleClose();
                  }}
                >
                  OK
                </button>
              </div>
            ) : (
              /* CONFIRMATION STATE */
              <div className="modal-body">
                {error && <div className="alert alert-danger">{error}</div>}

                <p className="mb-4">
                  This will log you out of <strong>all devices</strong>.
                </p>

                <div className="modal-footer px-0">
                  <button
                    type="button"
                    className="btn brand-purple-outline"
                    onClick={handleClose}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn brand-purple-inline"
                    onClick={handleLogoutAll}
                    disabled={isLoading}
                  >
                    {isLoading ? "Logging out..." : "Log out everywhere"}
                  </button>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
}
